import React from 'react'
import { Radio, Tabs } from 'antd';
import "./style.css"


const CustomRadio =({value, options, size, defaultValue, onChange, ...props})=>{

    return (
        <Radio.Group   optionType='button' value={value}  options={options} size={size || "large"} onChange={onChange} {...props}/>
    );

}

export default CustomRadio;
